import getPassengerToAutoAssignSelectedPassengerClass
    from "@CheckOrder/features/classPicker/functions/getPassengerToAutoAssignSelectedPassengerClass";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

export default function useHandlePassengerClassSelect(
    passengerId: number,
    setSelectedPassengerClass: (passengerClass: AvailablePassengerClassType) => void,
    setNewlySelectedPassengerClass: (passengerClass: AvailablePassengerClassType) => void,
    isReturn?: boolean
) {
    const {
        ticket: {singleSelectedPassengerClasses, returnSelectedPassengerClasses},
        passengers,
    } = useAppSelector((state) => (state.checkOrder))

    const selectedPassengerClasses = isReturn ? returnSelectedPassengerClasses : singleSelectedPassengerClasses

    const handlePassengerClassSelect = (passengerClass: AvailablePassengerClassType) => () => {
        const assignablePassengers = getPassengerToAutoAssignSelectedPassengerClass(
            selectedPassengerClasses,
            passengers,
            passengerId,
            passengerClass
        )

        const passengerClassForOneUser = passengerClass.users === 1
        const moreThenOneAutoAssignableUsers = assignablePassengers.length > 1
        const passengerClassHasNoPassengerGroups = !selectedPassengerClasses.classToPassengersMap[passengerClass.id]
        // there is a "not full class" where the user is being added
        const notFullPassengerGroupTypeExists = () => (selectedPassengerClasses.classToPassengersMap[passengerClass.id].some((passengerIdsGroup) => (
            passengerIdsGroup.length < passengerClass.users
        )))

        const userWasTheOnlyPassengerWithThisClass = (
            !!selectedPassengerClasses.classToPassengersMap[passengerClass.id]
            && selectedPassengerClasses.classToPassengersMap[passengerClass.id].length === 1
            && selectedPassengerClasses.classToPassengersMap[passengerClass.id][0].length === 1
            && selectedPassengerClasses.classToPassengersMap[passengerClass.id][0][0] === passengerId
        )

        if (
            passengerClassForOneUser
            || moreThenOneAutoAssignableUsers
            || passengerClassHasNoPassengerGroups
            || !notFullPassengerGroupTypeExists()
            || userWasTheOnlyPassengerWithThisClass
        ) {
            setSelectedPassengerClass(passengerClass)
            return
        }

        setNewlySelectedPassengerClass(passengerClass)
    }

    return {
        handlePassengerClassSelect,
    }
}